import React from 'react';
import './CourseStepForExam.module.scss';
import { observer } from 'mobx-react';
import { useViewportState } from '../../../../../commonv3/hooks/useViewportState';
import { Button } from '../../../../../commonv3/components/atoms/buttons/Button';
import StepTitleSPImage from './images/step_title_sp.png';
import Step1SPImage from './images/step1_sp.png';
import Step2SPImage from './images/step2_sp.png';
import Step3SPImage from './images/step3_sp.png';
import Step4SPImage from './images/step4_sp.png';
import DoneBlockSPImage from './images/done_block_sp.png';
import StepTitleImage from './images/step_title.png';
import Step1Image from './images/step1.png';
import Step2Image from './images/step2.png';
import Step3Image from './images/step3.png';
import Step4Image from './images/step4.png';
import SheChanImage from './images/she_chan.png';
import { SpBr } from '../../../../../commonv3/components/atoms/layouts/br';
import { SheEventClient, EventCategory } from '../../../../../commonv3/events/SheEventClient';

type StepItemsData = {
  buttonText: string;
  url: string;
  imageUrl: string;
  imageUrlSp: string;
  eventName: string;
};

const StepItems: StepItemsData[] = [
  {
    buttonText: 'イベントを見る',
    url: '/home/events/1008',
    imageUrl: Step1Image,
    imageUrlSp: Step1SPImage,
    eventName: 'watch_presentation_event',
  },
  {
    buttonText: '資料を見る',
    url: 'https://docs.google.com/spreadsheets/d/17plZfR-LcR5DyPhS4bPyM2ikvZExM7b3Ea2j0j2vEA0/edit#gid=450551016',
    imageUrl: Step2Image,
    imageUrlSp: Step2SPImage,
    eventName: 'open_requirements_definition_sheet',
  },
  {
    buttonText: 'ドリルをはじめる',
    url: 'https://docs.google.com/presentation/d/1kwoYWajwjhcSEtHf3rblOvhzfbcPQ3Kqiz3OG90jacU/edit#slide=id.g1334dcc5301_0_101',
    imageUrl: Step3Image,
    imageUrlSp: Step3SPImage,
    eventName: 'start_photoshop_drill_for_banner',
  },
  {
    buttonText: 'イベントを見る',
    url: '/home/events/1006',
    imageUrl: Step4Image,
    imageUrlSp: Step4SPImage,
    eventName: 'watch_coding_ws_event',
  },
];

type StepItemProps = {
  buttonText: string;
  url: string;
  imageUrl: string;
  eventName: string;
};

const StepItem = ({ buttonText, url, imageUrl, eventName }: StepItemProps) => {
  const viewport = useViewportState();
  return (
    <div styleName="step-item-wrapper">
      <img src={imageUrl} styleName="step-image" alt="step_image" />
      <div styleName="step-button">
        <Button
          type="normal"
          size={viewport.isMobile ? 'm' : 's'}
          onClick={() => SheEventClient.reportKarteEvent(EventCategory.STEP, eventName, {})}
          href={url}
          target="_blank"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export const CourseStepForExam = observer(() => {
  const viewport = useViewportState();
  const doneText = 'Webサイト完成';
  const description = (
    <p>
      補習コンテンツは実技試験に挑戦する過程で
      <SpBr />
      「ちょっと自信ないな」と思った時におすすめ！
      <br />
      足りないスキルの補強に活用してね。
    </p>
  );

  return (
    <div styleName="step-wrapper">
      {viewport.isMobile ? (
        <>
          <img src={StepTitleSPImage} styleName="step-title-image-sp" alt="step_title_sp_image" />
          {StepItems.map((item, index) => {
            return (
              <StepItem
                key={index}
                buttonText={item.buttonText}
                url={item.url}
                imageUrl={item.imageUrlSp}
                eventName={item.eventName}
              />
            );
          })}
          <img src={DoneBlockSPImage} styleName="done-block-sp" alt="done_block_sp_image" />
          <div styleName="description">{description}</div>
        </>
      ) : (
        <>
          <img src={StepTitleImage} styleName="step-title-image" alt="step_title_image" />
          <div styleName="step-header">
            <div styleName="text-step">ステップ</div>
            <div styleName="text-contents">補修コンテンツ</div>
          </div>
          {StepItems.map((item, index) => {
            return (
              <StepItem
                key={index}
                buttonText={item.buttonText}
                url={item.url}
                imageUrl={item.imageUrl}
                eventName={item.eventName}
              />
            );
          })}
          <div styleName="done-section">
            <div styleName="done-block">
              <p>{doneText}</p>
            </div>
            <img src={SheChanImage} styleName="she-chan-image" alt="she_chan_image" />
            <div styleName="description">{description}</div>
          </div>
        </>
      )}
    </div>
  );
});
